import { prefixHost } from "../panes/utils";

export const en: Record<string, string> = {
  // Nav labels
  "shortcut.websites": "Websites",
  "shortcut.studentweb": "Student web",
  "shortcut.intranet": "Intranet",

  "shortcut.studentweb.href": prefixHost("www", "/en/student"),
  "shortcut.intra.href": prefixHost("intra", "/en"),
  "shortcut.external.href": prefixHost("www", "/en"),
  "shortcut.missing-links.href":
    "https://www.kth.se/en/student/it/studenttjanster/personligamenyn/canvasrum-saknas-1.1435250",

  "shortcut.missing-links": "Read more about missing Canvas rooms",
  "Personal menu": "Personal menu",

  lang_other: "På svenska",
  Groups: "Groups",
  Profile: "Profile",
  Logout: "Logout",
  BetaTooltip: "Give us feedback or disable the beta",
  Programme: "Programme",
  Schedule: "Schedule",
  Services: "Services",
  Studies: "Studies",
  active_courses: "Active",
  all_courses: "All courses",
  cstate_CANCELLED: "Cancelled course",
  cstate_DEACTIVATED: "Deactivated course",
  cstate_ESTABLISHED: "Established course",
  "Om kursen (kurs-PM m.m.)": "About Course (Course Memo etc.)",
  "Canvas:": "Canvas",
  "Alla kursrum": "All Canvas Rooms",
  groups_banner_prefix:
    "The Group web as a collaboration space will close on December 31, 2026. As an administrator, you now need to export the group's content and/or delete the group. \n" +
    "Please note: Starting October 1, 2026, parts of the group web that are no longer in use will be gradually shut down, for example, group websites that have already been migrated or have been inactive for an extended period. \n" +
    "You can find more information in the news article:",
  groups_banner_link_text_1: "The Group web and Social close during the fall, 2026",
  groups_banner_link_text_2: "The Group web as a collaboration space closes during the fall, 2026.",
  groups_banner_text_end: "Support and instructions for how to export a group web can be found in:",
  "Administrera kurs": "Course Admin",
  "Hantera Omgångar/grupper": "Handle Rounds/Groups",
  Kursdeltagare: "Attendees",
  "Kursinformation i Kopps": "Course Information in Kopps",
  "Redigera introduktion till kursen": "Edit Course Introduction",
  "Skapa och publicera kurs-PM": "Create and Publish Course Memo",
  Kursvärdering: "Course Evaluation",
  "Se provresultat": "See Results",
  "Studentgruppen / Prenumeranter": "Student Group/Subscribers",
  "Sök tentamen": "Search Exam",
  hp: "credits", // Högskolepoäng
  antagna: "Admitted",
  registrerade: "Registered",
  omregistrerade: "Re-registered",
  omreg_lbl: "Re-registered",
  godkand: "Completed",
  om_kursen: "Course Information",
  "Search for interesting groups to follow":
    "Search for interesting groups to follow",
  "Profile Image": "Profile Image",
  "Help / feedback for the personal menu":
    "Help / feedback for the personal menu",
  "Home page": "Home page",
  "Relevant information right now. Course registration, Exam registration":
    "Relevant information right now. Course registration, Exam registration",
  "My education": "My education",
  "Overview of your studies. Programmes, courses, results on courses":
    "Overview of your studies. Programmes, courses, results on courses",
  Examinations: "Examinations",
  "Sign up for examinations": "Sign up for examinations",
  Transcripts: "Transcripts",
  "Degree Certificate": "Degree Certificate",
  "Apply for degree certificate": "Apply for degree certificate",
  Teaching: "Teaching",
  "KTH Webmail": "KTH Webmail",
  "News feed": "News feed",
  "News from your courses, groups and programmes":
    "News from your courses, groups and programmes",
  "Direct notifications": "Direct notifications",
  "dn-new": "new",
  "Change password": "Change password",
  "Manage KTH account": "Manage your KTH account",
  "Wireless network": "Wireless network",

  Settings: "Settings",
  "About me": "About me",
  "My Profile": "My Profile",
  "Forward KTH email": "Forward KTH email",
  "Contact details": "Contact details",
  "(in LADOK)": "(in LADOK)",
  "My Settings": "My Settings",
  "Subscriptions, my schedule": "Subscriptions, my schedule",
  "Export My schedule (e.g. to your mobile phone)":
    "Export My schedule (e.g. to your mobile phone)",

  "Kurs-PM": "Course Memo",
  "i Canvas": "in Canvas",
  VT: "VT",
  HT: "HT",
  term1: "VT",
  term2: "HT",
  Kursen: "The Course",
  "My Programmes": "My Programmes",
  Favourites: "Favourites",
  "Find groups": "Find groups",
  "My Groups": "My Groups",
  // Services
  "LADOK for Students": "LADOK for Students",
  "service_menu_change_banner": "The service menu was changed on 16/2-2026. For more information regarding this change, please see the article",
  "service_menu_change_link_text": "Changes to KTH's Personal Menu",
  "service_menu_change_link_url": "https://intra.kth.se/en/utbildning/e-larande/e-larande-nyheter/forandringar-i-kth-s-personliga-meny-1.1454398",
  // Schedule
  "schedule_banner": "The schedule has changed since July 22, 2026. For more information about this change, see the article",
  "schedule_banner_link_text": 'New "My Schedule" in TimeEdit from July 22',
  "schedule_banner_link_url": "https://www.kth.se/student/nyheter/nytt-mitt-schema-i-timeedit-fran-22-juli-1.1485883",
  "schedule_banner_link_url_staff": "https://intra.kth.se/utbildning/schema-och-lokalbokning/sok-schema-1.279132",
  "Current Courses": "Current Courses",
  Other: "Other",
  "You don't belong to any programme.": "You don't belong to any programme.",
  "You don't belong to any groups.": "You don't belong to any group.",
  "You aren't studying any courses.": "You aren't studying any course.",
  "You aren't teaching any courses.": "You aren't teaching any course.",
  "Tillbaka till personliga menyn": "Back to Personal Menu",
  Examinationsrum: "Exam Room",
  Tillbaka: "Back",
  "Alla examinationsrum": "All exam rooms",
  "No rooms found in Canvas":
    "Associated room in Canvas is not yet published, or is missing.",
  "No rooms found in Canvas teaching":
    "Associated room in Canvas is missing, or you are not added to it.",
  "Program Room": "Program Room",
  prog_syllabus: "Syllabus",
};
